import {TranslationFunction} from "../../i18n/i18n";
import {CatalogValueDto} from "../../client/catalog/CatalogValueDto";
import {CatalogFormatter} from "../../common/catalog/CatalogFormatter";

export class SubmissionStateTypeFormatter {
    static formatSubmissionStateType(type: CatalogValueDto | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValue(type, "submissionStateType", t);
    }
}
